/**
 * @desc 获取年度销售计划指标
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.TheAnnualSalesPlanIndexQuery,
): Promise<
  defs.StandardReturn<Array<defs.QueryPlanSaleYearIndicatorResponse>>
> {
  return defHttp.post({
    url: '/web/sale/indicator/search',
    data,
  });
}

export function mock(
  data: defs.TheAnnualSalesPlanIndexQuery,
): Promise<
  defs.StandardReturn<Array<defs.QueryPlanSaleYearIndicatorResponse>>
> {
  return defHttp.post({
    url: '/mock/web/sale/indicator/search',
    data,
  });
}
